import { mapState } from 'pinia'

import {
  filterNavigation,
  getBookmarkEntries,
  getFollowedTagEntries,
  getListEntries,
} from 'src/components/navigation/filter.js'
import { ROOT_ITEMS, TIMELINES } from 'src/components/navigation/navigation.js'
import NavigationEntry from 'src/components/navigation/navigation_entry.vue'
import NavigationEntryList from 'src/components/navigation/navigation_entry_list.vue'
import NavigationPins from 'src/components/navigation/navigation_pins.vue'

import { useAnnouncementsStore } from 'src/stores/announcements'
import { useBookmarkFoldersStore } from 'src/stores/bookmark_folders.js'
import { useChatsStore } from 'src/stores/chats.js'
import { useFollowRequestsStore } from 'src/stores/follow_requests.js'
import { useFollowedTagsStore } from 'src/stores/followed_tags.js'
import { useInstanceStore } from 'src/stores/instance.js'
import { useInstanceCapabilitiesStore } from 'src/stores/instance_capabilities.js'
import { useListsStore } from 'src/stores/lists.js'
import { useSyncConfigStore } from 'src/stores/sync_config.js'
import { useUsersStore } from 'src/stores/users.js'

const NavPanel = {
  props: ['forceExpand', 'forceEditMode'],
  components: {
    NavigationEntryList,
    NavigationEntry,
    NavigationPins,
  },
  data() {
    return {
      editMode: false,
      showTimelines: false,
      showLists: false,
      showTags: false,
      showBookmarkFolders: false,
    }
  },
  methods: {
    toggleTimelines() {
      this.showTimelines = !this.showTimelines
    },
    toggleLists() {
      this.showLists = !this.showLists
    },
    toggleTags() {
      this.showTags = !this.showTags
      const tags = useFollowedTagsStore()
      if (this.showTags && !tags.loaded) tags.load()
    },
    toggleBookmarkFolders() {
      this.showBookmarkFolders = !this.showBookmarkFolders
    },
    toggleEditMode() {
      this.editMode = !this.editMode
    },
    toggleCollapse() {
      useSyncConfigStore().setSimplePrefAndSave({
        path: 'collapseNav',
        value: !this.collapsed,
      })
      useSyncConfigStore().pushSyncConfig()
    },
  },
  computed: {
    ...mapState(useListsStore, { listEntries: getListEntries }),
    ...mapState(useBookmarkFoldersStore, {
      bookmarkEntries: getBookmarkEntries,
    }),
    ...mapState(useFollowedTagsStore, {
      tagEntries: (store) => getFollowedTagEntries(store.tags),
    }),
    ...mapState(useAnnouncementsStore, ['unreadAnnouncementsCount']),
    ...mapState(useInstanceCapabilitiesStore, [
      'pleromaBookmarkFoldersAvailable',
    ]),
    ...mapState(useInstanceStore, ['privateMode']),
    ...mapState(useSyncConfigStore, {
      collapsed: (store) => store.prefsStorage.simple.collapseNav,
      pinnedItems: (store) =>
        new Set(store.prefsStorage.collections.pinnedNavItems),
    }),
    ...mapState(useUsersStore, ['currentUser']),
    ...mapState(useFollowRequestsStore, ['followRequestsCount']),
    ...mapState(useChatsStore, ['unreadChatsCount']),
    timelinesItems() {
      return filterNavigation(
        Object.entries({ ...TIMELINES })
          // do not show in timeliens list since it's in a better place now
          .filter(([key]) => key !== 'bookmarks')
          .map(([k, v]) => ({ ...v, name: k })),
      )
    },
    rootItems() {
      return filterNavigation(
        Object.entries({ ...ROOT_ITEMS }).map(([k, v]) => ({ ...v, name: k })),
      )
    },
  },
}

export default NavPanel
